// ! automatically generated - Don't change this file manually
import PropTypes from 'prop-types';
import React from 'react';
const ICON_SIZE = { small: '1rem', medium: '1.25rem', large: '1.5rem' };;
export const IconLinkedin = React.forwardRef(({
  title,
  titleId: titleIdProp,
  desc,
  descId: descIdProp,
  size,
  height: heightProp,
  width: widthProp,
  ...props
}, ref) => {
  const internalTitleId = React.useId();
  const internalDescId = React.useId();
  const titleId = title != null ? titleIdProp ?? internalTitleId : undefined;
  const descId = desc != null ? descIdProp ?? internalDescId : undefined;
  const height = ICON_SIZE[size] ?? size ?? heightProp ?? "1em";
  const width = ICON_SIZE[size] ?? size ?? widthProp ?? "1em";
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width} height={height} role={title == null ? 'presentation' : 'img'} data-icon-name="linkedin" ref={ref} aria-labelledby={titleId} aria-describedby={descId} {...props}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path stroke="currentColor" strokeWidth={1.4} d="M2.321 9.339a.005.005 0 0 0-.005.005v12.651c0 .003.002.005.005.005h3.927a.005.005 0 0 0 .005-.005V9.344a.005.005 0 0 0-.005-.005H2.321ZM2 4.28a2.283 2.283 0 0 0 4.564 0A2.28 2.28 0 0 0 4.284 2 2.28 2.28 0 0 0 2 4.28Zm16.055 17.715c0 .003.002.005.005.005h3.922a.005.005 0 0 0 .005-.005v-6.942c0-3.409-.736-6.03-4.72-6.03-1.91 0-3.194 1.05-3.718 2.043a.005.005 0 0 1-.005.003h-.043a.005.005 0 0 1-.005-.005v-1.72a.005.005 0 0 0-.005-.005H9.729a.005.005 0 0 0-.005.005v12.651c0 .003.003.005.005.005h3.917a.005.005 0 0 0 .005-.005v-6.253c0-1.653.311-3.253 2.357-3.253 2.02 0 2.047 1.89 2.047 3.356v6.15Z" /></svg>;
});
IconLinkedin.displayName = "IconLinkedin";
IconLinkedin.propTypes = {
  /**
   * Icon title
   */
  title: PropTypes.string,
  /**
   * Icon title ID
   */
  titleId: PropTypes.string,
  /**
   * Icon description
   */
  desc: PropTypes.string,
  /**
   * Icon description ID
   */
  descId: PropTypes.string,
  /**
   * Size of the icon, these values are based on 'rem'
   * to make it adjustable to the user browser configuration.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['small', 'medium', 'large'])])
};